import { inject, bindable, IEventAggregator } from "aurelia";
import { getLogger } from "../../common/logging";
import { FormFieldChanged } from "../../messages/form-field-changed";
import { fieldOf } from "../../common/element-field";
import numeral from "numeral";
import { elementId } from "../../common/element-id";

let log = getLogger("multiply");

@inject(Element, IEventAggregator)
export class MultiplyCustomAttribute {
  @bindable with;
  @bindable target;

  constructor(element, ea) {
    this.element = element;
    this.ea = ea;
  }

  binding() {
    this.elementId = elementId(this.element);

    this.subscription = this.ea.subscribe(FormFieldChanged, (message) => {
      this.onFormFieldChanged(message);
    });
  }

  detaching() {
    this.subscription.dispose();
  }

  onFormFieldChanged(message) {
    if (message.elementId !== this.elementId) return;
    const { model } = fieldOf(this.element);
    let a = numeral(message.value).value();
    let b = numeral(model[this.with]).value();
    let sum = a * b;
    if (!sum) sum = 0;
    model[this.target] = sum;
  }
}
